import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "../constants/api.routes";
import { ISpecificationTemplate, ISpecificationTemplateDetailResponse } from "./interface/responses/ISpecificationTemplate";
import { IMergeSpecificationTemplateRequest, ISpecificationTemplatesGetRequest } from "./interface/ISpecificationTemplate";


export class SpecificationTemplateServices {

    getSpecificationTemplate(templateId: string) {
        return httpClient.get<ISpecificationTemplateDetailResponse>(API_ROUTES.Specification.template.get(templateId));
    }

    getSpecificationTemplates(payload: ISpecificationTemplatesGetRequest) {
        const queryParams = new URLSearchParams();
        if (payload.limit) queryParams.append('limit', payload.limit.toString());
        if (payload.search) queryParams.append('search', payload.search);
        if (payload.offset) queryParams.append('offset', payload.offset.toString());
        if (payload.sortBy) queryParams.append('sortBy', payload.sortBy);
        return httpClient.get<ISpecificationTemplate[]>(API_ROUTES.Specification.template.root + `?${queryParams.toString()}`);
    }

    mergeSpecificationTemplate(payload: IMergeSpecificationTemplateRequest) {
        return httpClient.patch(API_ROUTES.Specification.merge(payload.companyId, payload.targetSpecificationId, payload.sourceTemplateId), payload);
    }
}

export const specificationTemplateServices = new SpecificationTemplateServices();   
